import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'gatsby';
import Welcome from './welcome.js';
import isBrowser from '../../../../utils/isBrowser';
import promotion from '../../../../../promotion_config';
import lottery_logo from './logo.png';

// Regarding page refresh... The onActive and refresh methods are for
// triggering and catching page refreshes in order to set the active element without
// re-rendering the whole dang page

const PrimaryNav = ({ user, actions, menuLinks }) => {
    const refresh = () => {
        var UA = navigator.userAgent,
            iOS = !!UA.match(/iPad|iPhone/i);

        if (iOS) {
            // this is a hack to make the menu dissappear on iOS
            // it triggers an error, but without the error occuring, the
            // nav menu will not dissapear. It could be a simpler issue, but
            // for now, this will cause the ui to work
            document.getElementsByTagName('body').click();
        }

        document.getElementById('nav-target').blur();
    };

    const isPHP = url => {
        return url.toString().slice(-4) === '.php';
    };

    const isActive = uri => {
        const page = uri.replace('.php', '').split('/');
        if (isBrowser()) {
            return window.location.pathname.includes(page[1]);
        }
        return false;
    };

    return (
        <div id="nav-target" className="navigation">
            <nav className="navbar navbar-expand-md">
                <div
                    className="flush-row collapse navbar-collapse"
                    id="primary-nav"
                >
                    <div className="col navbar-nav d-flex justify-content-around p-3">
                        {menuLinks.map((link, key) => {
                            const usePartial = link.uri !== '/';
                            return (
                                <li
                                    className="nav-item nav-link"
                                    key={`main-menu--${key}`}
                                >
                                    {isPHP(link.uri) ? (
                                        <a
                                            className={`${
                                                isActive(link.uri)
                                                    ? 'active'
                                                    : ''
                                            }`}
                                            href={promotion.appUrl + link.uri}
                                        >
                                            {link.title}
                                        </a>
                                    ) : (
                                        <Link
                                            to={link.uri}
                                            className=""
                                            partiallyActive={usePartial}
                                            activeClassName="active"
                                            onClick={refresh}
                                        >
                                            {link.title}
                                        </Link>
                                    )}
                                </li>
                            );
                        })}
                        <Welcome
                            className="d-md-none py-3"
                            user={user}
                            actions={actions}
                        />
                        <a
                            className="d-md-none"
                            href={promotion.lotteryUrl}
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            <img
                                src={lottery_logo}
                                alt={promotion.lotteryName}
                                className="img-fluid d-block mx-auto"
                            />
                        </a>
                    </div>
                </div>
            </nav>
        </div>
    );
};

PrimaryNav.propTypes = {
    menuLinks: PropTypes.arrayOf(
        PropTypes.shape({
            uri: PropTypes.string,
            title: PropTypes.string,
        })
    ),
};

export default PrimaryNav;
